// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1O24w","title":"Images90_title__1MlR-","images":"Images90_images__2xBn5"};